<template>
  <!-- 审核弹窗 -->
  <a-drawer
    :visible="visible"
    title="详情"
    :width="750"
    centered
    :footer="null"
    :body-style="{ paddingBottom: '54px' }"
    @close="onClose"
  >
    <template v-if="visible">
      <div class="title_box">基本信息</div>
      <a-descriptions title="" :column="2" class="descriptions-box1">
        <a-descriptions-item label="学员姓名">
          {{ processData.employeeName }}
        </a-descriptions-item>
        <a-descriptions-item v-if="processData.idPhoto" label="证件照">
          <a-image :src="processData.idPhoto" />
        </a-descriptions-item>
        <a-descriptions-item label="专业">
          {{ processData.majorName }}
        </a-descriptions-item>
        <a-descriptions-item v-if="processData.idPhoto" label="准考证号">
          {{ processData.examinationNo }}
        </a-descriptions-item>
        <a-descriptions-item label="性别">
          {{ processData.sex }}
        </a-descriptions-item>
        <a-descriptions-item label="身份证号">
          {{ processData.account }}
        </a-descriptions-item>
        <a-descriptions-item label="出生年月">
          {{ processData.birthdayText }}
        </a-descriptions-item>
        <a-descriptions-item label="民族">
          {{ processData.nation }}
        </a-descriptions-item>
        <a-descriptions-item label="首次报考年月">
          {{ processData.firstRegistrationDateText }}
        </a-descriptions-item>
        <a-descriptions-item label="毕业年月">
          {{ processData.graduationDateText }}
        </a-descriptions-item>
        <a-descriptions-item
          v-if="processData.selfStudyCertificateNumber"
          label="自考毕业证号"
        >
          {{ processData.selfStudyCertificateNumber }}
        </a-descriptions-item>
      </a-descriptions>
      <a-descriptions title="" :column="1" class="descriptions-box1">
        <a-descriptions-item
          label="政治思想及学习工作表现（含奖励或处分情况）"
          class="descriptions-item1"
        >
          {{ processData.detail }}
        </a-descriptions-item>
      </a-descriptions>

      <div class="title_box">相关材料</div>
      <a-descriptions title="" :column="1" class="descriptions-box2">
        <a-descriptions-item label="身份证">
          <div class="image-idcard">
            <a-image :src="processData.idCardFront" />
            <a-image :src="processData.idCardBack" />
          </div>
        </a-descriptions-item>
        <a-descriptions-item label="广东省高等教育自学考试考生信息简表">
          <a-image :src="processData.gdRegistration" />
        </a-descriptions-item>
        <a-descriptions-item
          v-if="processData.moeRegistration"
          label="教育部学历证书电子注册备案表"
        >
          <a-image :src="processData.moeRegistration" />
        </a-descriptions-item>
        <!-- <a-descriptions-item label="学位申请表">
          <a-image :src="processData.degreeApplicationUrl" />
        </a-descriptions-item> -->
        <a-descriptions-item
          v-if="processData.languageScore"
          label="外语成绩单"
        >
          <a-image :src="processData.languageScore" />
        </a-descriptions-item>
        <a-descriptions-item v-if="isOpen" label="是否自愿参加学位论文辅导培训">
          <span v-if="processData.isVoluntaryTraining === 'JOIN'">是</span>
          <span v-else-if="processData.isVoluntaryTraining === 'NOT_JOIN'">
            否
          </span>
          <span v-else>--</span>
        </a-descriptions-item>
        <a-descriptions-item
          v-if="processData.other1 || processData.other2 || processData.other3"
          label="其他材料"
        >
          <a-image v-if="processData.other1" :src="processData.other1" />
          <a-image v-if="processData.other2" :src="processData.other2" />
          <a-image v-if="processData.other3" :src="processData.other3" />
        </a-descriptions-item>
      </a-descriptions>
    </template>

    <template #footer>
      <div class="btn_box">
        <a-button style="margin-right: 12px" @click="onClose"> 关闭 </a-button>
        <a-button
          v-if="
            !type &&
            (!processData.selfStudyCertificateNumber ||
              !processData.moeRegistration ||
              !processData.idPhoto)
          "
          type="primary"
          @click="supplementGraduationMaterials"
        >
          补充毕业材料
        </a-button>
      </div>
    </template>

    <graduation-materials
      :id="data.paperApplyRecordId"
      v-model:visible="graduationMaterialsVisible"
      :type="type"
      :data="data"
      @updateList="getDetails"
    />
  </a-drawer>
</template>

<script setup>
import { reactive, defineProps, watch, ref, defineEmits } from "vue";
import dayjs from "dayjs";
import { Modal } from "ant-design-vue";

import { getOther } from "@/api/common-paper.js";
import {
  getUserAccount,
  getStudentAccount,
} from "@/api/my_page/student_info/index.js";
import { extractBirthAndGender } from "@/utils/function.js";

import GraduationMaterials from "./graduation-materials.vue";

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  data: {
    type: Object,
    default: () => {
      return {};
    },
  },
  type: {
    type: String,
    default: "",
  },
  majorName: {
    type: String,
    default: "",
  },
  examTicketNum: {
    type: String,
    default: "",
  },
  isOpen: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(["update:visible", "confirm"]);

// 关闭抽屉
const onClose = () => {
  emit("update:visible", false);
};

const timeFun = (params) => {
  if (!params) return "";
  return dayjs(params).format("YYYY-MM");
};

const graduationMaterialsVisible = ref(false);
const supplementGraduationMaterials = () => {
  Modal.confirm({
    title: "提示",
    content:
      "当获得自考毕业证号和教育部学历证书电子注册备案表后，需要进行对应材料补充，若未获得请暂时关闭当前弹窗，若已获得则点击继续。",
    cancelText: "关闭",
    okText: "点击继续",
    onOk: () => {
      graduationMaterialsVisible.value = true;
    },
  });
};

const getDetails = async () => {
  try {
    let res2 = {};
    if (props.type == "dissertation") {
      res2 = await getStudentAccount();
      processData.majorName = props.majorName;
      processData.examinationNo = props.examTicketNum;
      processData.account = res2.account;
    } else {
      let res = await getUserAccount();
      processData.employeeName = res.userName;
      processData.account = res.idCard;
      processData.sex =
        extractBirthAndGender(res.idCard).gender == 1 ? "男" : "女";
      Object.assign(processData, res);

      res2 = await getOther(props.data.paperApplyRecordId);
    }
    res2.graduationDateText = timeFun(res2.graduationDate);
    res2.firstRegistrationDateText = timeFun(res2.firstRegistrationDate);
    processData.birthdayText = timeFun(
      extractBirthAndGender(processData.account).birthDate
    );

    Object.assign(processData, res2);
    if (res2.sex == 1) {
      processData.sex = "男";
    } else if (res2.sex == 2) {
      processData.sex = "女";
    }
  } catch (error) {
    console.log(error);
  }
};

const processData = reactive({});
watch(
  () => props.visible,
  (val) => {
    if (val) {
      getDetails();
    }
  }
);
</script>

<style lang="less" scoped>
.img_box {
  display: flex;
  flex-wrap: wrap;
  .title {
    position: relative;
    left: -20px;
    width: 100%;
    padding-bottom: 5px;
    font-weight: 600;
  }
}

.descriptions-box1 {
  :deep(.ant-descriptions-item-label) {
    display: flex;
    justify-content: flex-end;
    min-width: 110px;
    padding-right: 8px;
  }
}
.descriptions-box2 {
  :deep(.ant-descriptions-item-label) {
    display: flex;
    justify-content: flex-end;
    width: 110px;
    padding-right: 8px;
  }
}
.ant-descriptions {
  width: 80%;
  margin: 0 auto;
  :deep(.descriptions-item1) {
    .ant-descriptions-item-container {
      display: flex;
      flex-direction: column;
      .ant-descriptions-item-label {
        display: inline-flex;
        justify-content: initial;
      }
    }
  }
}
:deep(.ant-image) {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90px;
  height: 130px;
  margin-right: 6px;
  margin-bottom: 6px;
  overflow: hidden;
  background: #d9d9d9;
  border: 1px dashed #d9d9d9;
}
.image-idcard {
  display: flex;
  :deep(.ant-image) {
    width: 130px;
    height: 90px;
  }
}

.process_form {
  position: absolute;
  bottom: 54px;
  left: 24px;
  width: 80%;
}
.title_box {
  position: relative;
  display: flex;
  align-items: center;
  padding-bottom: 10px;
  padding-left: 10px;
  font-weight: 600;
  &::before {
    position: absolute;
    left: 0;
    width: 3px;
    height: 18px;
    background: @primary-color;
    content: "";
  }
}

.btn_box {
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 99;
  width: 100%;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
  border-top: 1px solid #e9e9e9;
}
</style>
